import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5f3ea9fb&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./company.vue?vue&type=style&index=0&id=5f3ea9fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ea9fb",
  null
  
)

component.options.__file = "company.vue"
export default component.exports